module.exports = __webpack_public_path__ + "static/media/MHRP29N0008.59f39f23.svg";